import { getGlobalSettings } from '../../../../../utils/global_settings';
import { DATA_TYPE } from '../../../../../components/AdvancedExportModal/configs/constants';

export const allowedExportPages = [
  'app_insights_summary_show',
  'apps_performance',
  'rank_history_show',
  'apps_reviews',
  'apps_engagement',
  'review_analysis/app_reviews_sentiments_show',
  'review_analysis/app_reviews_intents_show',
  'review_analysis/app_reviews_keywords_show',
  'apps_downloads_and_revenue',
];

export const allowedMarketExportPages = [
  'performance',
  'rank',
  'reviews',
  'overview',
];

const rootNode = document.getElementById('app-insights-general-root');

const { permissions, currentUser } = getGlobalSettings();

const rawReport = JSON.parse(rootNode?.dataset?.report || '{}');
const initialDataType = rawReport?.data_type || DATA_TYPE.BASE;

const dataApp = JSON.parse(rootNode?.dataset?.app || '{}');
const currentPage = rootNode?.dataset?.pageName || '';

export const initParams = {
  permissions: {
    ...permissions,
    ...JSON.parse(rootNode?.dataset?.permissions || '{}'),
    current_user_id: currentUser.id,
    customer_id: currentUser.customerId,
  },
  app: dataApp,
  notification: JSON.parse(rootNode?.dataset?.notification || '{}'),
  preferredCountries: JSON.parse(rootNode?.dataset?.preferredCountries || '[]'),
  maxPeriod: rootNode?.dataset?.maxPeriod ? parseInt(rootNode?.dataset?.maxPeriod, 10) : 365,
  periodFilters: JSON.parse(rootNode?.dataset?.periodFilters || '{}'),
  pageName: currentPage,
  allowedPages: JSON.parse(rootNode?.dataset?.allowedPages || '[]'),
  forecastPresent: rootNode?.dataset?.forecastPresent === 'true',
  maxDate: rootNode?.dataset?.maxDate,
  dataType: initialDataType,
};
